var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightModeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.57 17.93C7.01 16.85 6 15.04 6 13C6 9.69 8.69 7 12 7C15.31 7 18 9.69 18 13C18 15.05 16.97 16.86 15.4 17.94",
    fill: "black",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4V2M3 13H1M23 13H21M19.7782 5.22183L18.364 6.63604M5.63602 6.63604L4.2218 5.22182M4 18H20M8 21H16M8.57 17.93C7.01 16.85 6 15.04 6 13C6 9.69 8.69 7 12 7C15.31 7 18 9.69 18 13C18 15.05 16.97 16.86 15.4 17.94L8.57 17.93Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightModeWhite);
export default __webpack_public_path__ + "static/media/light-mode-white.8dd185d624d6f5dc701543876d425bd6.svg";
export { ForwardRef as ReactComponent };